import { FormattedMessage } from 'react-intl';

type SidePanelHeaderProps = {
  toggleSidePanel: () => void;
};

export function Header({ toggleSidePanel }: SidePanelHeaderProps) {
  return (
    <div className="offcanvas-header d-flex bg-blur bg-lvl1 bg-opacity-70 p-0 px-1 z-3">
      <div className="flex-grow-1 flex-x gap-2 p-3">
        <div className="offcanvas-heading">
          <h1 className="h4">
            <FormattedMessage id="essential.workspace.right.panel.title" />
          </h1>
        </div>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={toggleSidePanel}
          data-e2e="popover-close-button"
        />
      </div>
    </div>
  );
}
